import React from 'react';
import { Route, Link, Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as rb from 'react-bootstrap';

import Map from './Home/Map';
import Countdown from './Home/Countdown';
import Story from './Home/Story';

class App extends React.Component {
  constructor(props) {
    super();
    this.state = {
      apiUrl: window.$apiUrl,
      scrolled: 0
    };

  }
  componentDidMount() {
    
  }
  render() {

    return (
      <div className="App">
        <div>
          <Map />
        </div>
        <div>
          <Countdown />
        </div>
        <div style={{ borderTop: '2px solid #ddd' }}>
          <Story />
        </div>

      </div>
    );
  }
}

export default App;

